import graphic_design from "../images/pattern-graphic-design.svg";
import UIUX from "../images/pattern-ui-ux.svg";
import apps from "../images/pattern-apps.svg";
import illustrations from "../images/pattern-illustrations.svg";
import photography from "../images/pattern-photography.svg";
import motionGraphics from "../images/pattern-motion-graphics.svg";

const Solutions = () => {
	return (
		<div className='w-full flex flex-col items-center'>
			<h1 className='mt-8 mb-4 xl:mt-66 font-bold text-36 md:text-44 xl:text-56 text-black leading-45 md:leading-55 xl:leading-71 text-center'>
				Design solutions made easy
			</h1>
			<p className='w-285 md:w-573 xl:w-730 mb-8 xl:mb-20 font-medium text-16 md:text-lg text-medium_brown leading-26 text-center'>
				With over ten years of experience in various design disciplines, I’m your one-stop shop for
				your design needs.
			</p>

			{/* All cards */}
			<div className='w-full flex flex-col xl:flex-row'>
				{/* Graphic Design, UI/UX, Apps, Illustrations */}
				<div className='md:w-690 xl:w-732 flex flex-col md:flex-row md:justify-between'>
					{/* Graphic Design */}
					<div className='w-343 md:w-333 xl:w-354 h-364 p-6 flex flex-col justify-between bg-galactic_blue rounded-lg'>
						<img src={graphic_design} alt='graphic design' className='w-128 h-192 ml-auto' />
						<p className='font-bold text-24 leading-30 text-white'>Graphic Design</p>
					</div>

					{/* UI/UX, Apps and Illustrations */}
					<div className='w-full md:w-333 xl:w-354 md:h-364 mt-6 md:mt-0 flex flex-wrap justify-between'>
						{/* UI/UX */}
						<div className='w-159 md:w-155 xl:w-164 h-182 p-6 flex flex-col justify-between bg-summer_yellow rounded-lg'>
							<img src={UIUX} alt='UI/UX' className='ml-auto' />
							<p className='font-bold text-24 leading-30 text-white'>UI/UX</p>
						</div>

						{/* Apps */}
						<div className='w-159 md:w-155 xl:w-164 h-182 p-6 flex flex-col justify-between bg-pink rounded-lg'>
							<img src={apps} alt='apps' className='ml-auto' />
							<p className='font-bold text-24 leading-30 text-white'>Apps</p>
						</div>

						{/* Illustrations */}
						<div className='w-343 md:w-333 xl:w-354 h-158 mt-6 p-6 flex flex-col justify-between bg-light_red rounded-lg'>
							<img src={illustrations} alt='illustrations' className='ml-auto' />
							<p className='font-bold text-24 leading-30 text-white'>Illustrations</p>
						</div>
					</div>
				</div>

				{/* Photography and Motion Graphics */}
				<div className='w-full xl:w-354 mt-6 xl:mt-0 xl:ml-auto flex flex-col md:flex-row xl:flex-col md:justify-between'>
					{/* Photography */}
					<div className='w-343 md:w-333 xl:w-354 h-182 p-6 flex flex-col justify-between bg-cyan rounded-lg'>
						<img src={photography} alt='photography' className='ml-auto' />
						<p className='font-bold text-24 leading-30 text-white'>Photography</p>
					</div>
					{/* Motion Graphics */}
					<div className='w-343 md:w-333 xl:w-354 h-182 xl:h-158 mt-6 md:mt-0 p-6 flex flex-col justify-between bg-dark_purple rounded-lg'>
						<img src={motionGraphics} alt='motion graphics' className='ml-auto' />
						<p className='font-bold text-24 leading-30 text-white'>Motion Graphics</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Solutions;
